import "./ProyectosCommon.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { CatalogoItemResponse } from "../../../shared/response/proyectos/CatalogoItemResponse";
import { CatalogoPrecioSavePayload } from "../../../shared/services/api/payload/proyectos/CatalogoPrecioSavePayload";
import { CatalogoPrecioSaveService } from "../../services/proyectos/CatalogoPrecioSaveService";

const TIPOP_LABEL: Record<string, string> = { smmlv: "SMMLV", ipc: "IPC", fijo: "Fijo", volatil: "Volátil" };

/** Modal pequeño para editar el precio referencial de un ítem del catálogo. */
export class CatalogoPrecioModal extends BaseSmallModalFormComponent<
  CatalogoItemResponse,
  CatalogoPrecioSavePayload,
  CatalogoPrecioSaveService
> {
  private _precio!: HTMLInputElement;

  constructor(
    private readonly _item: CatalogoItemResponse,
    private readonly _onSavedCb: (item: CatalogoItemResponse) => void,
  ) {
    super(new CatalogoPrecioSaveService());
  }

  protected get title(): string { return "Precio referencial"; }
  protected get saveText(): string { return "Guardar"; }
  protected override get saveInitiallyDisabled(): boolean { return false; }

  protected renderBody(): string {
    const it = this._item;
    return `
      <div class="cl-form-fields">
        <div class="cl-form-group">
          <label class="cl-form-label" for="cp-precio">${this._esc(it.nombre)}</label>
          <div class="pr-form-note" style="margin-bottom:6px">
            ${this._esc(it.unidad || "")}${it.cantUnidad ? " · " + this._esc(it.cantUnidad) : ""} · ${TIPOP_LABEL[it.tipoP] ?? it.tipoP}
          </div>
          <input id="cp-precio" class="sx-input sx-input--numeric" type="number" min="0" step="1"
                 value="${it.precioReferencial ?? ""}" placeholder="0" inputmode="numeric">
          <span class="pr-form-note">Precio orientativo del catálogo (COP). Vacío = sin precio.</span>
        </div>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._precio = el.querySelector<HTMLInputElement>("#cp-precio")!;
    this._precio.focus();
    this._precio.select();
  }

  protected buildPayload(): CatalogoPrecioSavePayload {
    const raw = this._precio.value.trim();
    return {
      id: this._item.id,
      precio: raw === "" ? null : Math.max(0, Math.floor(Number(raw) || 0)),
      tipoP: this._item.tipoP,
    };
  }

  protected override onSaved(item: CatalogoItemResponse): void {
    this._onSavedCb(item);
    this.dispose();
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
}
